import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RouterLinkFactory {
  /**
   * Navigate application to homepage.
   *
   * Homepage is main page (component), which is rendered after login.
   * It is always safe to redirect to homepage.
   */
  homepage(): string[] {
    return ['/dashboard'];
  }

  /**
   * Navigate application to my-offers page.
   */
  myOffers(): string[] {
    return ['/dashboard/my-offers'];
  }

  /**
   * Navigate application to add offer page.
   */
  addMyOffers(): string[] {
    return ['/dashboard/my-offers/add'];
  }

  /**
   * Navigate application to my-offers details page.
   */
  myOffersDetails(id: string): string[] {
    return ['/dashboard/my-offers/details', id];
  }

  /**
   * Navigate application to my-offers benf page.
   */
  myOffersBenf(id: string): string[] {
    return ['/dashboard/my-offers/benf', id];
  }

  /**
   * Navigate application to my-offers rates page.
   */
  myOffersRates(id: string): string[] {
    return ['/dashboard/my-offers/rates', id];
  }

  /**
   * Navigate application to my-offers edit page.
   */
  editMyOffers(id: string): string[] {
    return ['/dashboard/my-offers/edit', id];
  }

  /**
   * Navigate application to my-offers edit page.
   */
  myOffersNotes(id: string): string[] {
    return ['/dashboard/my-offers/notes', id];
  }

  /**
   * Navigate application to profile page.
   */
  profile(): string[] {
    return ['/dashboard/profile'];
  }

  /**
   * Navigate application to messages page.
   */
  messages(): string[] {
    return ['/dashboard/messages'];
  }

  /**
   * Navigate application to messages details page.
   */
  messagesDetails(id: string): string[] {
    return ['/dashboard/messages/details', id];
  }

  /**
   * Navigate application to staff page.
   */
  staff(): string[] {
    return ['/dashboard/staff'];
  }

  /**
   * Navigate application to notification page.
   */
  notifications(): string[] {
    return ['/dashboard/notification'];
  }
}
